import type { ISwSettings } from "app/@types/ISwSettings";
import { isPostPurchaseLanding } from "app/components/FirstWeekMonthlyPromo/utils/isPostPurchaseLanding";
import {
    isTrialOrAfterTrial,
    isPendingTrialStatus,
    isMonthlyPaymentPeriod,
    isNoTouch,
    isSI,
    isRoleAdmin,
    isMcpNt,
} from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const isFirstWeekCampaignEligible = (
    swSettings: ISwSettings,
    conditions?: Record<string, string | number | boolean>,
): boolean => {
    return (
        isNoTouch(swSettings) &&
        !isSI(swSettings) &&
        !isMcpNt(swSettings) &&
        !isTrialOrAfterTrial(swSettings) &&
        !isPendingTrialStatus(swSettings) &&
        !!conditions?.isMarketingGreenLight &&
        isMonthlyPaymentPeriod(swSettings) &&
        !isPostPurchaseLanding() &&
        isRoleAdmin(swSettings)
    );
};
